import { render, staticRenderFns } from "./SupportCaseWorkflow.vue?vue&type=template&id=212be3fe&"
import script from "./SupportCaseWorkflow.vue?vue&type=script&lang=ts&"
export * from "./SupportCaseWorkflow.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports